module.exports = __webpack_public_path__ + "static/media/api_footer.db0c9de4.png";